import { render, staticRenderFns } from "./tax-table.vue?vue&type=template&id=7fda4e35&scoped=true&"
import script from "./tax-table.ts?vue&type=script&lang=ts&"
export * from "./tax-table.ts?vue&type=script&lang=ts&"
import style0 from "./tax-table.scss?vue&type=style&index=0&id=7fda4e35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fda4e35",
  null
  
)

export default component.exports